import { Product } from "../../types/Product";
import {
  useCountriesTranslations,
  useProductTranslations
} from "../../hooks/TranslationHooks";

const SalesRegionsArea = ({ product }: { product: Product }) => {
  const tp = useProductTranslations();
  const tc = useCountriesTranslations();
  const salesRegions = product.sales_regions || [];
  return salesRegions.length > 0 ? (
    <div className={"product-sales-regions"}>
      <h4>{tp("sales_regions.heading")}:</h4>
      <ul>
        {salesRegions.map(country => (
          <li key={country}>{tc(country.toUpperCase())}</li>
        ))}
      </ul>
    </div>
  ) : null;
};

export default SalesRegionsArea;
